import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import { Users, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ParentSetup = () => {
  const navigate = useNavigate();
  const [parentName, setParentName] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!parentName.trim() || !email.trim()) {
      setError('Please fill in all fields');
      return;
    }

    try {
      setLoading(true);
      setError('');
      
      const response = await axios.post(`${API}/parent/register`, {
        parent_name: parentName,
        email: email
      });

      // Store parent info in localStorage
      localStorage.setItem('userRole', 'parent');
      localStorage.setItem('parentId', response.data.parent_id);
      localStorage.setItem('parentName', parentName);
      
      navigate('/parent-dashboard');
    } catch (err) {
      console.error('Error registering parent:', err);
      setError(err.response?.data?.detail || 'Failed to register. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 md:p-8" style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <div className="max-w-2xl w-full">
        <Button
          onClick={() => navigate('/role-selection')}
          variant="ghost"
          className="mb-6 text-lg font-semibold text-white hover:scale-110 transition-transform"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back
        </Button>

        <Card className="p-8 md:p-12 bg-white/95 backdrop-blur-sm shadow-2xl bounce-in" style={{
          borderRadius: '32px'
        }}>
          <div className="text-center mb-8">
            <Users className="w-16 h-16 mx-auto mb-4 text-blue-500" />
            <h2 className="text-3xl font-bold text-gray-800 mb-2">Parent Account Setup</h2>
            <p className="text-gray-600 text-lg">Monitor your children's learning progress</p>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-lg font-semibold text-gray-700 mb-2">Your Name</label>
              <Input
                type="text"
                placeholder="Enter your name..."
                value={parentName}
                onChange={(e) => setParentName(e.target.value)}
                className="text-xl p-6 border-4 border-blue-300 focus:border-blue-500"
                style={{ borderRadius: '16px' }}
              />
            </div>

            <div>
              <label className="block text-lg font-semibold text-gray-700 mb-2">Email Address</label>
              <Input
                type="email"
                placeholder="your.email@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="text-xl p-6 border-4 border-blue-300 focus:border-blue-500"
                style={{ borderRadius: '16px' }}
              />
            </div>

            {error && (
              <Card className="p-4 bg-red-50 border-2 border-red-300" style={{ borderRadius: '12px' }}>
                <p className="text-red-700 text-center">{error}</p>
              </Card>
            )}

            <Button
              onClick={handleSubmit}
              disabled={loading}
              className="w-full py-6 text-xl font-bold transition-all duration-300 hover:scale-105"
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '16px'
              }}
            >
              {loading ? 'Creating Account...' : 'Continue as Parent'}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ParentSetup;
